import { z } from 'zod';
import { VehicleSchema } from '../vehicle';

const schema = VehicleSchema.model;

export const locationTrackingVehicleSchema = schema
  .pick({
    _id: true,
    title: true,
  })
  .extend({
    /** plate number */
    plate: schema.shape.registration.shape.plate,
    type: schema.shape.classification.shape.type,
  });
export type LocationTrackingVehicle = z.infer<typeof locationTrackingVehicleSchema>;
